import { api } from '../../../renderer/services/http';

export const grnService = {
  getAll: async () => api<any[]>('/api/purchase/grn'),
  create: async (body: any) => api('/api/purchase/grn', { method: 'POST', body: JSON.stringify(body) }),
  returnDelivery: async (body: any) => api('/api/purchase/returns', { method: 'POST', body: JSON.stringify(body) }),
};
